import { useEffect, useState } from 'react';

const CYCLE_MS = 1800;

export function useCyclingLabel(labels: readonly string[], isPaused: boolean): string | undefined {
  const [index, setIndex] = useState(0);
  const count = labels.length;

  useEffect(() => {
    if (isPaused || count < 2) {
      return;
    }
    const timer = setTimeout(() => setIndex((current) => current + 1), CYCLE_MS);
    return () => clearTimeout(timer);
  }, [isPaused, index, count]);

  return labels[index % count];
}
